import { useEffect, useState } from "react";
import { Ticket } from "../../../models/Ticket";
import { get } from "../../../api";
import { GET_USER_SELECTS_URL } from "../../../api/apiRoutes";
import useFacility from "../../../../utils/hooks/useFacility";

export default function useCourtPasses() {
  const facilityIds = useFacility();
  const [loading, setLoading] = useState(false);
  const [availablePasses, setAvailablePasses] = useState<Ticket[]>([]);

  const getAvailablePasses = async () => {
    setLoading(true);
    const { result, isError } = await get(GET_USER_SELECTS_URL(facilityIds));
    if (!isError) {
      setAvailablePasses(result);
    }
    setLoading(false);
  };

  // Karnety ważne w terminie zajęć. Wyczerpana pula zostaje na liście — karta jest wyszarzona.
  const getFilteredPasses = (exerciseStartTime: number) => {
    return availablePasses.filter(
      (item) => item.ticket === false && item.validfrom <= exerciseStartTime && exerciseStartTime <= item.validto,
    );
  };

  useEffect(() => {
    if (facilityIds) {
      getAvailablePasses();
    }
    //eslint-disable-next-line
  }, [facilityIds]);

  return {
    loading,
    availablePasses,
    getFilteredPasses,
    refetchPasses: getAvailablePasses,
  };
}
